import React, { FC } from "react";
import NthTextLink, {
  TextLinkProps,
  TextLinkTargetType,
} from "@narvar/nth-bit-text-link";
import { useViewportConfig } from "@narvar/nth-kit-returns-headless";

const TextLink: FC<
  Omit<TextLinkProps, "target"> & {
    target?: "_self" | "_blank" | TextLinkTargetType;
    stopPropagation?: boolean;
  }
> = ({ href, target, stopPropagation, onClick, ...props }) => {
  const { externalLinkHandler } = useViewportConfig();
  const isExternal = !!href && !onClick;
  const t =
    target === "_self"
      ? TextLinkTargetType.SELF
      : target === "_blank"
        ? TextLinkTargetType.BLANK
        : target;

  const onClickHandler = isExternal
    ? (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
        event.preventDefault();
        if (stopPropagation) event.stopPropagation();

        if (externalLinkHandler) {
          externalLinkHandler({
            url: href ?? "",
            target: t,
          });
        } else {
          window.open(href ?? "", t);
        }
      }
    : onClick;

  return (
    <NthTextLink href={href} target={t} onClick={onClickHandler} {...props} />
  );
};

export default TextLink;
